module.exports = __webpack_public_path__ + "img/product1_1.5b221b03.png";